

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
    // Thu gọn / mở ra panel float right
    $(".close_floatright").on("click", function (e) {
        e.preventDefault();
        $("#libraryMainsite-t-float_right").toggleClass("active");
    });
});
